import { useState } from 'react';
import { Modal } from './modal';
import { Button } from './button';

interface ErrorModalProps {
  open: boolean;
  errorMessage: string;
  onClose: () => void;
}

export function ErrorModal({ open, errorMessage, onClose }: ErrorModalProps) {
  const [showDetails, setShowDetails] = useState(false);
  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header title="Something went wrong" />
      <Modal.Body>
        <p>We ran into a problem. Sorry about that. Please try reloading the page.</p>
        <p>
          If you continue to see this message, please{' '}
          <a
            href="mailto:iqd-support@hi-level.co.uk?subject=iQD%20Pro%20Issue"
            target="_top"
            className="font-medium text-hilevel-red hover:underline"
          >
            email support
          </a>
          .
        </p>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => setShowDetails((v) => !v)}
          aria-expanded={showDetails}
        >
          {showDetails ? 'Hide error details' : 'Show error details'}
        </Button>
        {showDetails && (
          <div className="rounded-md border border-hilevel-border bg-hilevel-offwhite p-3 font-mono text-xs text-hilevel-slate whitespace-pre-wrap break-words">
            {errorMessage}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
}
